import React from 'react';

import Lozenge from '@atlaskit/lozenge';
import { gridSize } from '@atlaskit/theme';

import { IssueCategory } from 'src/redux/jira/constants';
import { IssueTransition } from 'src/redux/jira/types';

type StatusLozengeProps = {
  transition: IssueTransition;
};

/* eslint @typescript-eslint/ban-types: "warn" */
const StatusLozenge: React.FC<StatusLozengeProps> = ({ transition }) => {
  const appearanceFromStatusCategory = (
    category: IssueCategory | undefined
  ) => {
    switch (category) {
      case IssueCategory.InProgress:
        return 'inprogress';
      case IssueCategory.Done:
        return 'success';
      default:
        return 'default';
    }
  };

  return (
    <Lozenge
      appearance={appearanceFromStatusCategory(
        transition.to?.statusCategory.key
      )}
      maxWidth={gridSize() * 11}
    >
      {transition.name}
    </Lozenge>
  );
};

export default StatusLozenge;
